import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from ".././Helmet";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/ramadan.webp";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import moment from 'moment-hijri';
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));
const TITLE = "كم باقي على رمضان 2027 - العد التنازلي لرمضان";
const DESCRIPTION = "كم باقي على رمضان 2027؟ العد التنازلي لشهر رمضان المبارك 1445 هـ يوفر لك المعلومات الدقيقة حول موعد بداية رمضان، كم يوم متبقي لرمضان، وعدد الأيام الباقية حتى حلول الشهر الفضيل. تابع العد التنازلي لرمضان وتعرف على المدة المتبقية حتى بداية الصيام والاحتفال بالشهر الكريم. اكتشف متى رمضان وكم تبقى لرمضان بأفضل طريقة مع العد التنازلي للشهر المبارك.  ";
const KEYWORDS = "رمضان 2027, كم باقي على رمضان 2027, كم باقي لرمضان, كم باقي على رمضان, العد التنازلي لرمضان, كم باقي على رمضان العد التنازلي, كم يوم باقي لرمضان, باقي على رمضان, كم يوم باقي على رمضان, عد تنازلي لرمضان, كم تبقى لرمضان, متى رمضان العد التنازلي, كم باقي يوم على رمضان, رمضان العد التنازلي, كم ضايل لرمضان, كم تبقى على رمضان, كم باقي على رمضان 1445, كم باقي على رمضان عد تنازلي, كم باقي ع رمضان, العد التنازلي لشهر رمضان, باقي كم يوم على رمضان, كم بقي لرمضان, متى رمضان عد تنازلي, كم متبقي على رمضان, كم يوم على رمضان, عد تنازلي رمضان, باقى كام يوم على رمضان, عداد رمضان, كم باقي عن رمضان, كم باقي رمضان, كم يتبقى على رمضان, باقي لرمضان, كم باقي علي رمضان, رمضان كم باقي, موعد رمضان عد تنازلي, كم يوم ضايل لرمضان, كم تبقى على رمضان العد التنازلي, كم بقي على رمضان, كم باقي على شهر رمضان, كم باقي لشهر رمضان, ‏كم باقي على رمضان, العدد التنازلي لرمضان, عدد التنازلي لرمضان, العد التنازلي رمضان, موعد رمضان العد التنازلي, كم باقي يوم لرمضان, كم باقي على رمضان؟, باقي كم على رمضان, كم باقي علا رمضان, كم باقي على رمضان المبارك, فاضل كم يوم على رمضان, كم يوم متبقي لرمضان, كم يوم ضل لرمضان, كم يوم بقي لرمضان, باقي ع رمضان, كم باقي على, كم باقي عل رمضان, كم شهر باقي على رمضان";
const OG_URL = "https://do-calculate.com/articles-ar/ramadan/";
function Ramadan() {
    const [ramadanDates, setRamadanDates] = useState([
        // default value for 2027, will be replaced when DB data arrives
        { name: 'رمضان 2027', date: new Date("2027-02-08T00:00:00") },
        { name: 'رمضان 2028', date: new Date("2028-01-28T00:00:00") },
        { name: 'رمضان 2029', date: new Date("2029-01-16T00:00:00") }
    ]);
    const nextRamadan = ramadanDates.find(d => d.name === 'رمضان 2027')?.date || new Date("2027-02-18T00:00:00");
    const dayNameArabic = nextRamadan.toLocaleDateString('ar-EG', { weekday: 'long' });
    useEffect(() => {
        async function fetchRamadanDates() {
            try {
                const datesCol = collection(db, "dates");
                const querySnapshot = await getDocs(datesCol);
                let fetchedRamadan2027Date = null;
                const newRamadanDates = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    if (data.ramadan) {
                        const date = data.ramadan.toDate ? data.ramadan.toDate() : new Date(data.ramadan);
                        if (date.getFullYear() === 2027) {
                            fetchedRamadan2027Date = date;
                            newRamadanDates.push({ name: 'رمضان 2027', date: date });
                        }
                    }
                });
                if (fetchedRamadan2027Date) {
                    setRamadanDates(prevDates =>
                        prevDates.map(item =>
                            item.name === 'رمضان 2027'
                                ? { ...item, date: fetchedRamadan2027Date }
                                : item
                        )
                    );
                } else {
                    console.warn("No Ramadan 2027 date found in DB. Using default.");
                }
            } catch (error) {
                console.error("Error fetching Ramadan dates:", error);
            }
        }
        fetchRamadanDates();
    }, []);
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(nextRamadan));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(nextRamadan));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, nextRamadan]);
    // Generate Schema.org structured data for Ramadan Article
    const generateSchemaData = () => {
        // NewsArticle Schema (like Al Jazeera)
        const articleSchema = {
            "@context": "https://schema.org",
            "@type": "Article",
            "mainEntityOfPage": OG_URL,
            "headline": TITLE,
            "description": DESCRIPTION,
            "image": [
                {
                    "@type": "ImageObject",
                    "url": `https://do-calculate.com${imageUrl}`,
                    "width": 800,
                    "height": 450
                }
            ],
            "author": {
                "@type": "Organization",
                "name": "Do Calculate",
                "url": "https://do-calculate.com"
            },
            "publisher": {
                "@type": "Organization",
                "name": "Do Calculate",
                "url": "https://do-calculate.com",
                "logo": {
                    "@type": "ImageObject",
                    "url": "https://do-calculate.com/logo.png"
                }
            },
            "datePublished": "2027-01-10T00:00:00Z",
            "dateModified": new Date().toISOString()
        };
        // WebPage Schema
        const webPageSchema = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": TITLE,
            "description": DESCRIPTION,
            "url": OG_URL
        };
        // FAQ Schema
        const faqSchema = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "كم باقي على رمضان 2027؟",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": `من المتوقع أن يبدأ شهر رمضان 2027 يوم ${dayNameArabic} بتاريخ ${nextRamadan?.toLocaleDateString('en-GB')} ميلادي و ${moment(nextRamadan).format('iDD/iMM/iYYYY')} هجري. باقي ${timeLeft.days} يوم على رمضان المبارك.`
                    }
                },
                {
                    "@type": "Question",
                    "name": "ما هي فوائد صيام شهر رمضان؟",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "لصيام شهر رمضان فوائد كثيرة تشمل: تحسين مستويات الدم، التقليل من مستويات الدهنيات الضارة، تنظيم ضغط الدم، الحفاظ على مستويات سكر الدم، محاربة أمراض السرطان والالتهابات، تحسين الهضم والجهاز الهضمي، وتحسين الوظائف العقلية والذهنية."
                    }
                },
                {
                    "@type": "Question",
                    "name": "كم عدد أيام شهر رمضان؟",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "يتراوح عدد أيام شهر رمضان بين 29 و30 يومًا، وفقًا لثبوت رؤية الهلال."
                    }
                }
            ]
        };
        // BreadcrumbList Schema
        const breadcrumbSchema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "الصفحة الرئيسية",
                    "item": "https://do-calculate.com/"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "المقالات",
                    "item": "https://do-calculate.com/articles-ar/"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "كم باقي على رمضان 2027",
                    "item": OG_URL
                }
            ]
        };
        return [articleSchema, webPageSchema, faqSchema, breadcrumbSchema];
    };
    return (
        <div className="rtl">
            {/* Schema is passed to SharedHelmet and will be added to <head> */}
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                IMAGE={imageUrl}
                SCHEMA={generateSchemaData()}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                كم باقي على رمضان 2027
            </h1>
            <Suspense fallback={<div>Loading...</div>}>
                <BlinkingText
                    text={`كم باقي على رمضان: من المتوقع أن يبدأ شهر رمضان 2027 يوم ${dayNameArabic} بتاريخ ${nextRamadan?.toLocaleDateString('en-GB')} ميلادي و ${moment(nextRamadan).format('iDD/iMM/iYYYY')} بحسب التقويم الهجري.`}
                />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th >يوم</th>
                                <th >ساعة</th>
                                <th >دقيقة</th>
                                <th >ثوانٍ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days">{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes">{timeLeft.minutes}</td>
                                <td id="seconds">{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='alert alert-info' style={{ marginTop: '20px', marginBottom: '20px', fontSize: '20px', textAlign: 'center' }}>
                    إذهب إلى عداد التسبيح (الاستعفار) من <a href="/calculator/ar/tally-counter/">هنا</a>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>مواعيد رمضان القادمة</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>موعد رمضان</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>التاريخ</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>باقي</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ramadanDates.map((ramadan, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{ramadan.name}</td>
                                        <td style={{ padding: '12px' }}>{ramadan.date?.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(ramadan.date).days} يوم</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <Suspense fallback={<div>Loading...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>متى يبدأ شهر رمضان 2027؟</h3>
                    <p>
                        لم يتبق سوى أشهر قليلة على حلول شهر رمضان لعام 2027/1447، حيث تشير الحسابات الفلكية إلى أن بداية الشهر الفضيل ستكون يوم {dayNameArabic} {nextRamadan?.toLocaleDateString('en-GB')} فبراير/شباط 2027.
                    </p>
                    <p>
                        وسيتم تحري الهلال بعد مغيب شمس يوم {new Date(nextRamadan.getTime() - 24 * 60 * 60 * 1000).toLocaleDateString('ar-EG', { weekday: 'long' })} 29 شعبان 1447، الذي من المتوقع أن يوافق {new Date(nextRamadan.getTime() - 24 * 60 * 60 * 1000).toLocaleDateString('en-GB')} فبراير/شباط 2027 لتحديد الموعد الدقيق لبداية الصيام.
                    </p>
                    <p>
                        تعتمد الكثير من الدول العربية والإسلامية على الرؤية الشرعية للهلال باستخدام المراصد الفلكية امتثالا لحديث النبي محمد صلى الله عليه وسلم "لا تصوموا حتى تروا الهلال، ولا تفطروا حتى تروه، فإن غُمَّ عليكم فاقْدُروا له"، ومن المتوقع أن تدعو الدول الإسلامية إلى تحري الهلال مساء ذلك اليوم، ليتم الإعلان الرسمي عن بداية الشهر الفضيل بعد التثبت من الرؤية الشرعية.
                    </p>
                    <p>
                        وفقا لموقع <a href='/calculator/ar/gregorian_to_hijri/'>تحويل التاريخ</a> يصادف رمضان 2027 يوم {dayNameArabic} بتاريخ {nextRamadan?.toLocaleDateString('en-GB')} ميلادي و {moment(nextRamadan).format('iDD/iMM/iYYYY')} هجري، يمكنكم مشاهدة العد التنازلي لرمضان 2027 في هذا المقال.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Loading...</div>}>
                        <RelatedLinks />
                    </Suspense>
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        كم باقي على رمضان 2027 - العد التنازلي
                    </h3>
                    <p>
                        من خلال العد التنازلي لرمضان يمكنكم معرفة كم باقي لرمضان بالتقويم الميلادي والهجري، كما يمكنكم معرفة باقي على رمضان كم يوم، وكم تبقى لرمضان، كم تبقي لشهر رمضان بالأيام. شاهدوا العد التنازلي لشهر رمضان المبارك في الأعلى لمعرفة المدة المتبقية بالتفصيل (الأيام، الساعات، الدقائق، والثواني).
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        عدد ساعات الصيام في رمضان 2027
                    </h3>
                    <p>
                        من المتوقع أن يتفاوت عدد ساعات الصيام في الدول الإسلامية خلال شهر رمضان 2027. في الأيام الأولى، ستكون ساعات الصيام أقصر، حيث تقدر بقرابة 12 ساعة في العديد من الدول العربية، بما في ذلك السعودية ومصر والإمارات وقطر والكويت. ومع تقدم الأيام، تزداد ساعات الصيام تدريجيا لتقترب من 13 ساعة مع نهاية الشهر الفضيل.
                    </p>
                    <p>
                        سيلاحظ المسلمون في مختلف أنحاء العالم زيادة تدريجية في ساعات الصيام اليومية، إذ سيكون اليوم الأول من رمضان هو الأقصر في عدد ساعات الصيام، في حين سيشهد اليوم الأخير أطول ساعات الصيام، مما يعكس التغير الطبيعي في طول النهار مع مرور الأيام.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        رمضان - الشهر الفضيل
                    </h3>
                    <p>
                        شهر رمضان، الشهر التاسع في التقويم الهجري، يأتي بعد شهر شعبان مباشرةً، ويتميز بمكانته الخاصة في قلوب المسلمين. فهو شهر الصيام، أحد أركان الإسلام، حيث يمتنع المسلمون فيه عن الطعام والشراب والشهوات من طلوع الفجر حتى غروب الشمس. يبدأ شهر رمضان برؤية الهلال في يوم 29 من شهر شعبان، وإذا لم يتم رؤية الهلال، يكون شهر شعبان 30 يومًا ويكون اليوم التالي هو أول أيام رمضان المبارك. يتراوح عدد أيام شهر رمضان بين 29 و30 يومًا، وفقًا لثبوت رؤية الهلال.
                    </p>
                    <p>
                        وتحتفل المسلمون بعيد الفطر بعد انتهاء شهر رمضان، ويحمل شهر رمضان مكانة خاصة في التاريخ والتراث الإسلامي، حيث نزل القرآن الكريم في ليلة القدر من هذا الشهر الكريم. ويعد نزول الوحي على النبي محمد في أوقات متفرقة خلال هذا الشهر شهادة على عظمته ورسالته.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="كم باقي على شهر رمضان 2027 - العد التنازلي لرمضان المبارك"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        فوائد صيام شهر رمضان
                    </h3>
                    <p>
                        لصيام شهر رمضان فوائد كثيرة وعديدة لجسم الصائم، تشمل جميع النواحي البدنية والنفسية، وإذا قام الصائم بإتباع نظام غذائي صحي فإن الصيام سيحدث الكثير من التأثيرات الإيجايبة على صحة الصائم، حيث تشمل هذه الفوائد الكثيرة تحسين مستويات الدم، والتقليل من مستويات الدهنيات الضارة في الدم، وتنظيم ضغط الدم، والحفاظ على مستويات سكر الدم، والتوتر والقلق، ومحاربة أمراض السرطان والإلتهابات، فسنذكر لكم في هذا المقال الفوائد الكثيرة لصيام شهر رمضان المبارك.
                    </p>
                    <ul>
                        <li>تحسين مستويات الدم</li>
                        <li>التقليل من مستويات الدهنيات الضارة في الدم</li>
                        <li>تنظيم ضغط الدم</li>
                        <li>الحفاظ على مستويات سكر الدم</li>
                        <li>محاربة أمراض السرطان والإلتهابات</li>
                        <li>تحسين الهضم والجهاز الهضمي</li>
                        <li>تحسين الوظائف العقلية والذهنية</li>
                    </ul>
                </div>
                <br />
            </div>
        </div>
    );
}
export default Ramadan;